import { Middleware } from '@reduxjs/toolkit'
import { removeQuickOrderData, setQuickOrderData } from '../reducer/orders.reducer'
import { hideQuickTradePaperInstant, showQuickTradePaperInstant } from '../components/quickTradeWindow/quickTradeVisibility'

export const quickTradeVisibilityMiddleware: Middleware = () => (next) => (action) => {
    if (setQuickOrderData.match(action)) {
        if (action.payload.openDialog === true) {
            showQuickTradePaperInstant()
        } else if (action.payload.openDialog === false) {
            hideQuickTradePaperInstant()
        }
    } else if (removeQuickOrderData.match(action)) {
        hideQuickTradePaperInstant()
    }
    return next(action)
}
